/**
 * Bhagyank (Life Path) reference rows for /numerology/life-path/.
 *
 * Extracted from page.tsx 2026-08-08 so the page's visible table and the AEO
 * direct-answer composer (src/lib/numerology-answer.ts) read ONE array. A
 * second hand-typed copy for the answer block would be the drifting-copies
 * class rules 23/24 exist to prevent.
 *
 * It lives in `src/lib/` rather than beside the page because `src/lib/` may
 * not import from the UI layer (dep-cruiser `no-lib-importing-ui`) — the same
 * boundary that put the answer bounds in `lib/answer-bounds.ts`. Co-locating
 * it under `src/app/` made the composer reach across that boundary and failed
 * CI on 2026-08-08.
 *
 * The number->graha mapping is the classical Chaldean assignment already
 * mirrored in business/ishvaram/data/domain/astrology/numerology.yaml; the
 * theme/gift wording is the page's own evergreen editorial framing, which is
 * deliberately distinct from the day-personality framing of /numerology/[mulank].
 */

export type LifePath = { n: string; planet: string; theme: string; gift: string };

// Bhagyank / destiny-number themes — the karmic LIFE PURPOSE framing
// (deliberately distinct from the day-personality framing of /numerology/[mulank]).
export const LIFE_PATHS: LifePath[] = [
  {
    n: "1",
    planet: "Surya (Sun)",
    theme: "the path of the leader",
    gift: "to forge your own way and start what others only talk about",
  },
  {
    n: "2",
    planet: "Chandra (Moon)",
    theme: "the path of the peacemaker",
    gift: "to bring people together and feel what others cannot say",
  },
  {
    n: "3",
    planet: "Guru (Jupiter)",
    theme: "the path of the creator",
    gift: "to express, teach and uplift through words and imagination",
  },
  {
    n: "4",
    planet: "Rahu",
    theme: "the path of the builder",
    gift: "to turn discipline and patient work into something that lasts",
  },
  {
    n: "5",
    planet: "Budh (Mercury)",
    theme: "the path of the explorer",
    gift: "to adapt, communicate and thrive through change and freedom",
  },
  {
    n: "6",
    planet: "Shukra (Venus)",
    theme: "the path of the nurturer",
    gift: "to create harmony, beauty and responsibility in home and community",
  },
  {
    n: "7",
    planet: "Ketu",
    theme: "the path of the seeker",
    gift: "to question, research and reach the truth beneath the surface",
  },
  {
    n: "8",
    planet: "Shani (Saturn)",
    theme: "the path of the achiever",
    gift: "to master the material world through endurance and fair effort",
  },
  {
    n: "9",
    planet: "Mangal (Mars)",
    theme: "the path of the humanitarian",
    gift: "to serve a cause larger than yourself with courage and compassion",
  },
  {
    n: "11",
    planet: "Master of Chandra",
    theme: "the master path of the illuminator",
    gift: "the intuition of 2 raised to inspire — a calling to guide, not just soothe",
  },
  {
    n: "22",
    planet: "Master of Rahu",
    theme: "the master path of the master builder",
    gift: "the discipline of 4 raised to scale — to build something that serves many",
  },
  {
    n: "33",
    planet: "Master of Shukra",
    theme: "the master path of the master teacher",
    gift: "the creativity of 6 raised to heal — selfless service through wisdom",
  },
];
